import React, { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';
import './Website.css';

const plan = {
  id: 'Powerhouse',
  name: 'Powerhouse',
  price: '$9.99/year',
  summary: 'For deeper, repeated inbox cleanup.',
  features: ['Unlimited scan history', 'Deeper inbox lookback', 'Priority for heavy inboxes'],
};

export default function CheckoutPage() {
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);
  const user = auth.currentUser;

  async function ensureSignedIn() {
    if (auth.currentUser) return auth.currentUser;
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    const result = await signInWithPopup(auth, provider);
    return result.user;
  }

  async function startCheckout() {
    setBusy(true);
    setStatus('Preparing secure checkout...');
    try {
      const signedInUser = await ensureSignedIn();
      const userAccount = httpsCallable(functions, 'userAccount');
      await userAccount({ email: signedInUser.email });

      const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
      const { data } = await createCheckoutSession({ plan: plan.id });
      if (!data?.url) throw new Error('No checkout URL returned.');
      window.location.assign(data.url);
    } catch (err) {
      console.error('[checkout] failed:', err);
      setStatus(err?.message || 'Checkout failed. Please try again from the extension.');
      setBusy(false);
    }
  }

  return (
    <main className="site-page utility-page">
      <section className="section-inner checkout-grid">
        <div className="utility-copy">
          <p className="eyebrow">Secure upgrade</p>
          <h1>Upgrade the Gmail account you use with Unsubscriber.</h1>
          <p>
            Sign in with Google first so the extension account and Stripe subscription stay connected.
          </p>
          <div className="checkout-note">
            {user ? `Signed in as ${user.email}` : 'Google sign-in is required before payment.'}
          </div>
        </div>

        <article className="checkout-card">
          <span className="plan-label">Selected plan</span>
          <h2>{plan.name}</h2>
          <strong>{plan.price}</strong>
          <p>{plan.summary}</p>
          <ul>
            {plan.features.map((feature) => <li key={feature}>{feature}</li>)}
          </ul>
          {status && <div className={`status-message ${status.toLowerCase().includes('failed') ? 'status-error' : ''}`}>{status}</div>}
          <div className="checkout-actions">
            {user && (
              <button className="button button-secondary" type="button" onClick={() => signOut(auth)} disabled={busy}>
                Switch account
              </button>
            )}
            <button className="button button-primary" type="button" onClick={startCheckout} disabled={busy}>
              {busy ? 'Opening Stripe...' : 'Continue to Stripe'}
            </button>
          </div>
        </article>
      </section>
    </main>
  );
}
